// Creates collection of all the content that is used in slides.
// Generates an array that is consumed by a .map and displayed in order by carousel.

import growBarChart from '../../assets/slide_grow_bar_chart.png';
import efficientFrontierChart from '../../assets/slide_diversify_efficient_frontier.png';

// Creates slide collection with appropriate image for passive income number.
// INPUT: num (OR null/undef/bad data), whole number in millions for passive income
// OUTPUT: array, slide info ready to be consumed (first slide may be trimmed if input bad)
const createSlideCollection = (passiveIncomeNum) => {
  // Basic slide collection, potentially will be modified depending on passive income image
  const slideCollection = [
    {
      hookTitle: 'Objective: Income',
      mainTitle: 'Members can invest in professionally managed, well-leased properties.',
      bodyContent: 'RealtyMogul simplifies commercial real estate investing, giving Members access to vetted commercial real estate opportunities with the potential to generate income.',
      number: passiveIncomeNum,
      linkButtonDestination: '/benefits-of-investing#passive-income',
      captionText: 'of Property Value Offered on the RealtyMogul platform',
    },
    {
      hookTitle: 'Objective: Grow Portfolio Value',
      mainTitle: 'Consider real-estate as a vehicle for long-term appreciation',
      bodyContent: 'By investing in markets with the potential for growth, and properties with the potential for operational improvement, the RealtyMogul platform provides opportunities that may grow wealth over the long-term.',
      image: growBarChart,
      linkButtonDestination: '/benefits-of-investing#grow-value',
      captionText: 'NAREIT Equity REIT Index Annualized Return',
      disclosureTooltipText: 'Disclosure',
      disclosureTooltipParagraphs: [
        'Average annualized returns (%) as of 6/30/19',
        'NAREIT Equity REIT Index sourced from NCREIF (NCREIF.org). The NAREIT Equity REIT Index contains all publicly listed US Equity REITs not designated as Timber REITs or Infrastructure REITs. The NAREIT Equity REIT Index is illustrative of the potential average annualized returns available to investors in Commercial Real Estate. REITs offered by RealtyMogul are not publicly traded, require minimum investments and may have better or worse average annualized return performance compared to this Index.',
      ],
    },
    {
      hookTitle: 'Objective: Diversification',
      mainTitle: 'The strongest portfolios often include alternative investments.',
      bodyContent: 'The “efficient frontier” is the highest expected return for a defined level of risk. Including alternative investments like real estate in a portfolio has historically improved returns, while decreasing risk.',
      image: efficientFrontierChart,
      linkButtonDestination: '/benefits-of-investing#diversified-portfolio',
      captionText: 'Efficient Frontier: Traditional investments with & without alternatives',
      disclosureTooltipText: 'Disclosure',
      disclosureTooltipParagraphs: [
        'Based on the returns of the S&P 500 Index, Barclays U.S. Aggregate Bond Index, and the NCREIF (National Council of Real Estate Investment Fiduciaries) Index, with and without an asset allocation to direct real estate, over an 11-year time period (2006-2016).',
        'Each index provides a broad representation of a particular asset class and is not indicative of any investment. Asset allocation does not ensure a profit or protect against a loss. The rates of returns shown do not reflect the deduction of fees and expenses inherent in investing.',
      ],
    },
  ];

  // If we had bad data to generate passive income image we remove that slide entirely.
  if (slideCollection[0].image === null) {
    slideCollection.splice(0, 1);
  }

  return slideCollection;
};

export default createSlideCollection;
